import { lazyInitializeNotificationDiagnostics } from 'owa-mail-notification-diagnostics';
import { lazyInitializeNotificationManager } from 'owa-notification';
import { doAuthRedirect } from 'owa-service-error';
import { getScopedPath } from 'owa-url';
import { getHostLocation } from 'owa-url/lib/hostLocation';

export default async function initializeNotifications() {
    const initializeNotificationDiagnostics = await lazyInitializeNotificationDiagnostics.import();
    const windowUrlPath = window && window.location ? window.location.pathname : null;
    await initializeNotificationDiagnostics();
    await lazyInitializeNotificationManager.importAndExecute({
        channelEndpoint: getScopedPath('/owa', windowUrlPath) + '/notificationchannel',
        pingInterval: 300000,
        backoffMaximum: 64000,
        minimumReconnectInterval: 1000,
        readyCheckTimeout: 60000,
        handleSessionTimeout: () => {
            doAuthRedirect(getHostLocation());
        },
    });
}
